import { reactive, watch, SetupContext } from '@vue/composition-api';

import debounce from 'lodash.debounce';
import { VueSelectInstance } from 'vue-select';

import { mixpanel } from '@/helpers/analytics';

import { fetchSuggestQuery } from '@/modules/topics/api/suggestQueryApi';

export const useAdvisorSearchFormAutoComplete = (
  props: {
    value: string;
  },
  { emit }: Pick<SetupContext, 'emit'>,
) => {
  const state = reactive({
    searchText: props.value,
    suggestions: [] as string[],
    noDrop: props.value !== '',
  });

  watch(
    () => props.value,
    () => {
      state.searchText = props.value;
      state.suggestions = [];
    },
  );

  const fetchSuggestions = debounce(async (searchText: string) => {
    try {
      const response = await fetchSuggestQuery(searchText);
      state.suggestions = response.suggestions;
    } catch (e) {
      state.suggestions = [];
    }

    if (state.suggestions.length > 0) {
      const params: { [key: string]: string | number } = {
        searchText: searchText,
        suggestQueryCount: state.suggestions.length,
      };

      state.suggestions.forEach((suggestion, i) => {
        params[`suggestQueryR${i + 1}`] = suggestion;
      });

      mixpanel.track('Show Suggest Query', params);
    }
  }, 300);

  const select = (searchText: string) => {
    state.noDrop = true;
    state.searchText = searchText;
    emit('input', searchText);
    if (searchText) {
      mixpanel.track('Click Suggest Query', {
        search_text: state.searchText,
        select_query: searchText,
        position: state.suggestions.indexOf(state.searchText) + 1,
      });
    }
  };

  const input = (searchText: string) => {
    state.noDrop = false;
    state.searchText = searchText;
    emit('input', searchText);
  };

  const mapKeydown = (
    map: { [keyCode: number]: () => void },
    vm: VueSelectInstance,
  ) => ({
    ...map,
    // enter key
    13: () => {
      if (!state.noDrop && !vm.isComposing) {
        state.noDrop = true;
        vm.typeAheadSelect();
        vm.$el.querySelector('input')?.focus();
      }
    },
  });

  return {
    state,
    fetchSuggestions,
    select,
    input,
    mapKeydown,
  };
};
